import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Grid, Typography } from '@material-ui/core';
import { Link } from 'react-router-dom'
import config from '../../../helpers/config';

const useStyles = makeStyles(theme => ({

    roomIntro: props => ({
        margin: '150px 0px',
        padding: '100px 0px 125px 0px',
        position: 'relative',
        background: 'linear-gradient(45deg, #fcfeff, #e1d6e9)',

        '& .background': {
            position: 'absolute',
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            backgroundSize: 'contain',
            backgroundPosition: '100% 50%',
            backgroundRepeat: 'no-repeat',
            backgroundImage: props && props.roomIntro ? `url(${props.roomIntro.imgUrl})` : ''
        },

        '& .title': {
            color: theme.palette.primary.dark,
            textAlign: 'center',
            letterSpacing: '15px',
            '& h2': {
                fontWeight: 400
            }
            
        },

        '& .subTitle': {
            color: theme.palette.primary.main,
            textAlign: 'center',
            letterSpacing: '5px',
            padding: '40px 0px',

            '& h3': {
                display: 'inline-block',
                padding: '0px 20px',
                fontWeight: 400,

                [theme.breakpoints.down("xs")]: { 
                    padding: '10px 0px',
                    width: '100%'
                },
                [theme.breakpoints.up("xs")]: {
                    padding: '10px 0px',
                    width: '100%'
                },
                [theme.breakpoints.up("sm")]: {
                    padding: '0px 20px',
                    width: 'auto'
                },
                [theme.breakpoints.up("md")]: {
                    padding: '0px 20px',
                },
                [theme.breakpoints.up("lg")]: {
                    padding: '0px 20px',
                },
            }
        },

        '& .description': {
            textAlign: 'center',
            letterSpacing: '10px',

            '& h4': {
                display: 'inline-block',
                padding: '0px 20%',
                lineHeight: '40px',
                [theme.breakpoints.down("xs")]: { 
                    padding: '0px 15px',
                    letterSpacing: '5px',
                },
                [theme.breakpoints.up("xs")]: {
                    padding: '0px 5%',
                    letterSpacing: '10px',
                },
                [theme.breakpoints.up("sm")]: {
                    padding: '0px 10%',
                    letterSpacing: '10px',
                },
                [theme.breakpoints.up("md")]: {
                    padding: '0px 10%',
                    letterSpacing: '10px',
                },
                [theme.breakpoints.up("lg")]: {
                },
            }
        }
    }),

    roomDetail: props => ({
        position: 'relative',

        [theme.breakpoints.down("xs")]: { 
            padding: '75px 0px',
            margin: '50px 0px',
        },
        [theme.breakpoints.up("xs")]: {
            padding: '50px 0px',
            margin: '50px 0px',
        },
        [theme.breakpoints.up("sm")]: {
            padding: '25px 0px',
            margin: '50px 0px',
        },
        [theme.breakpoints.up("md")]: {
            padding: '75px 0px',
            margin: '50px 50px',
        },
        [theme.breakpoints.up("lg")]: {
            padding: '75px 0px',
            margin: '0px 100px',
        },

    
        '& .roomSection': {
            
            '& .roomItem': {
                zIndex: 1
            },
    
            '& .background': {
                opacity: 0.5,
                zIndex: 0,
                position: 'absolute',
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
                backgroundPosition: 'cover',
                backgroundAttachment: 'fixed',
                backgroundPosition: '0%',
                backgroundRepeat: 'no-repeat',
                backgroundImage: props && props.roomDetail ? `url(${config.S3Endpoint}${props.roomDetail.imgUrl})` : ''
            },

            '& .roomImgSection': {
                position: 'relative',
                width: '100%',

                [theme.breakpoints.down("xs")]: { 
                    marginTop: '0px',
                    height: '65vw',
                },
                [theme.breakpoints.up("xs")]: {
                    marginTop: '0px',
                    height: '65vw',
                },
                [theme.breakpoints.up("sm")]: {
                    marginTop: '0px',
                    height: '55vw',
                },
                [theme.breakpoints.up("md")]: {
                    marginTop: '0px',
                    height: '50vw',
                },
                [theme.breakpoints.up("lg")]: {
                    marginTop: '-50px',
                    height: '35vw',
                },

                '& .roomImgCurtain': {
                    position: 'absolute',
                    width: '95%',
                    height: '95%',
                    zIndex: 1,
                    top: 0,
                    overflow: 'hidden'
                },

                '& .roomImg': {
                    backgroundSize: 'contain',
                    backgroundPosition: '0%',
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    transition: '500ms all linear',
                    opacity: '1',
                    height: '100%',
                    width: '100%',
                    '&:hover': {
                        transform: 'scale(1.05)',
                        opacity: '0.8',
                    }
                },

                '& .roomBorder': {
                    position: 'absolute',
                    width: '90%',
                    height: '95%',
                    background: 'black',
                    zIndex: 0,
                    bottom: 0
                }
            },

            '& .roomDescSection': {
                [theme.breakpoints.down("xs")]: { 
                    padding: '50px',
                },
                [theme.breakpoints.up("xs")]: {
                    padding: '50px',
                },
                [theme.breakpoints.up("sm")]: {
                    padding: '0px 50px',
                },
                [theme.breakpoints.up("md")]: {
                    padding: '0px 100px',
                },
                [theme.breakpoints.up("lg")]: {
                    padding: '0px 100px',
                },

                '& .title': {

                    '& h2': {
                        fontWeight: 400
                    },
                    
                    '& h3': {
                        letterSpacing: '15px',
                        fontWeight: 400
                    },

                    '& .titleBorderBottom' : {
                        marginTop: '5px',
                        height: '5px'
                    }
                },

                '& .description': {
                    padding: '20px 0px 0px 0px',
                    
                    '& h4': {
                        letterSpacing: '5px',
                        padding: '15px 0px 0px 0px',
                        fontWeight: 400
                    },
                },

                '& .button': {
                    marginTop: '75px',
                    color: 'white',
                    padding: '10px 50px',
                    borderRadius: '20px',
                    textDecoration: 'none',
                    transition: 'all 300ms linear',

                    '&:hover': {
                        borderRadius: '5px'
                    }
                }
            }
        },
    }),


}));


const RoomIntro = (props) => {
    const classes = useStyles(props),
        {roomIntro} = props;

    if (!roomIntro) {
        return (<div></div>)
    }
    return (
        <div id="roomIntro" className={classes.roomIntro}>
            <div className="background"></div>
            <div className="title">
                <Typography variant="h2"><b>{roomIntro.name}</b></Typography>
            </div>
            <div className="subTitle">
                {roomIntro.title.map((d,i) => <Typography key={i} variant="h3"><b>&#10022; {d} &#10022;</b></Typography>)}
            </div>
            <div className="description">
                <Typography variant="h4">{roomIntro.desc}</Typography>
            </div>
        </div>
    )
}

const RoomDetail = (props) => {
    const classes = useStyles(props),
        {roomDetail} = props;

    if (!roomDetail) {
        return (<div></div>)
    }
    return (
        <div className={classes.roomDetail}>
        <Grid container className="roomSection" alignItems="center" >
            <div className="background"></div>
            {roomDetail.rooms.map((d, i) => {
                var even = i % 2 === 0,
                    background = even ? '#e0f2f4' : '#f7eaf3',
                    direction = even ? 'row' : 'row-reverse',
                    color = even ? '#28b8c3' : '#b8538d',
                    textAlign = even ? 'left' : 'right',
                    float= even ? 'left' : 'right',
                    roomImgStyle = {
                        backgroundImage: `url(${config.S3Endpoint}${d.featureImgUrl})`,
                        left: even ? 0 : 'auto',
                        right: even ? 'auto' : 0
                    },
                    roomBorderStyle = {
                        background,
                        right: even ? 0 : 'auto',
                        left: even ? 'auto' : 0
                    },
                    titleStyle = {
                        color,
                        textAlign
                    },
                    titleBorderBottomStyle = {
                        background: even ? `linear-gradient(45deg, ${color}, #fcfeff)` : `linear-gradient(45deg, #fcfeff, ${color})`       
                    },
                    descriptionStyle = {
                        textAlign
                    },
                    buttonStyle = {
                        backgroundColor: color,
                        float
                    }
                return (
                    <Grid key={i} container item={true} xs={12} sm={12} md={12} lg={12} xl={12} direction={direction} alignItems="center" className="roomItem">
                        <Grid item={true} xs={12} sm={5} md={5} lg={4} xl={4} className="roomImgSection">
                            <div className="roomImgCurtain">
                                <div className="roomImg" style={roomImgStyle}/>
                            </div>
                            <div className="roomBorder"  style={roomBorderStyle} />
                        </Grid>
                        <Grid item={true} xs={12} sm={7} md={7} lg={8} xl={8} className="roomDescSection">
                            <div className="title" style={titleStyle}>
                                <Typography variant="h3"><b>{d.name}</b></Typography>
                                <div className="titleBorderBottom" style={titleBorderBottomStyle}/>
                            </div>
                            <div className="description" style={descriptionStyle}>
                                <Typography variant="h4">{d.feature}</Typography>
                                <Typography variant="h4">{d.desc}</Typography>
                            </div>
                            <Link variant="contained" className="button" to={d.linkUrl} style={buttonStyle}>
                                <Typography variant="h5">了解更多</Typography>
                            </Link>
                        </Grid>
                    </Grid>
                );
            })}
        </Grid>
        
    </div>
    )
}


export default (props) => {

    return (
        <React.Fragment>
            <RoomIntro {...props} />
            <RoomDetail {...props} />
        </React.Fragment>
    )
}



// WEBPACK FOOTER //
// ./src/client/components/tour/Room.js